import { Component, OnInit } from '@angular/core';
import { SimpleModalComponent } from '@looorent/ngx-simple-modal';

@Component({
    selector: 'app-unsavedchangesdialog',
    templateUrl: './unsavedchangesdialog.component.html',
    styleUrls: ['./unsavedchangesdialog.component.scss'],
    standalone: false
})
export class UnsavedchangesdialogComponent extends SimpleModalComponent<any, any> {
  
  constructor() {
    super();
  }

  public AbandonChanges(){
    this.result = true;
    this.close();
  }
  public Cancel(){
    this.result = false;
    this.close();
  }
}
